export class ClientTelemedicineAccessRequest {
    idHealthUnit: number; 
    idSelfTriagePatient: number;
}